export default __webpack_public_path__ + "static/media/image.oensys-capital-pvt-ltd.cdde5e23.png";